import { render, staticRenderFns } from "./SgWirePhone.vue?vue&type=template&id=20e545b3&"
import script from "./SgWirePhone.vue?vue&type=script&lang=js&"
export * from "./SgWirePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports